import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScreensQuestionResource } from '@Components/mras/core';

@Component({
    selector: 'jhi-multi-select-input',
    templateUrl: './multi-select-input.component.html'
})
export class MultiSelectInputComponent implements OnInit {
    
    @Input() question: ScreensQuestionResource;
    @Input()
        value: string;
    @Output()
        valueChange = new EventEmitter<string>();

    @Input()
        summaryMode: boolean;

    @Input()
        name: string;
    @Input()
        options: any[];
    @Input()
        disabled: boolean;
    @Input()
        valueMapper: any;
    @Input()
        labelMapper: any;
    @Output()
        action = new EventEmitter<void>();

    values: string[];

    constructor() {}

    ngOnInit(): void {
        if (this.value != null) {
            this.values = this.value.split(',');
        }
    }

    toValue(option: any) {
        return this.valueMapper(option);
    }

    toLabel(option: any) {
        return this.labelMapper(option);
    }

    onClick() {
        if (this.value && this.value !== '') {
            this.valueChange.emit(null);
        }

        if (this.question.invalid) {
            this.question.invalid = false;
        }

        this.value = this.values.join(',');
        this.valueChange.emit(this.value);
        this.action.emit(null);
    }

    filter(options: any[]) {
        return options
            .map(e => {
                const value = this.toValue(e);
                if (value === 'UNKNOWN') {
                    return null;
                } else {
                    return e;
                }
            })
            .filter(e => e != null);
    }
}
